// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { kpiValueId } from './KpiValue';
import { fermentationId } from './Fermentation';
import { kpiFormulaId } from './KpiFormula';
import { fermentationProcedureId } from './FermentationProcedure';
import { fermentationGroupId } from './FermentationGroup';
import { z } from 'zod';
export const viewKpiValueWithFormula = z.object({
    id: kpiValueId,
    fermentation_id: fermentationId,
    effective_time_s: z.string(),
    value: z.string().nullable(),
    is_valid: z.boolean().nullable(),
    error_message: z.string().nullable(),
    computed_at: z.date().nullable(),
    formula_id: kpiFormulaId,
    formula_slug: z.string(),
    formula_name: z.string(),
    expression: z.string(),
    display_group: z.string().nullable(),
    display_order: z.number().nullable(),
    unit: z.string(),
    precision: z.number().nullable(),
    target_type: z.string().nullable(),
    procedure_id: fermentationProcedureId.nullable(),
    group_id: fermentationGroupId.nullable(),
});
//# sourceMappingURL=ViewKpiValueWithFormula.js.map